// import day_21_06_2024 from './2024_06_21.json'
// import day_23_07_2024 from './2024_07_23.json'
// import day_30_07_2024 from './2024_07_30.json'
// import day_06_08_2024 from './2024_08_06.json'
// import day_07_08_2024 from './2024_08_07.json'
// import day_08_08_2024 from './2024_08_08.json'
// import day_19_08_2024 from './2024_08_19.json'
// import day_28_08_2024 from './2024_08_28.json'
// import day_30_08_2024 from './2024_08_30.json'
// import day_10_09_2024 from './2024_09_10.json'
// import day_13_09_2024 from './2024_09_13.json'
import day_20_09_2024 from './2024_09_20.json'

export const PATCH_NOTES = [
  day_20_09_2024,
  //   day_13_09_2024,
  //   day_10_09_2024,
  //   day_30_08_2024,
  //   day_28_08_2024,
  //   day_19_08_2024,
  //   day_08_08_2024,
  //   day_07_08_2024,
  //   day_06_08_2024,
  //   day_30_07_2024,
  //   day_23_07_2024,
  //   day_21_06_2024,
]
